export function scrollTo(target, container, options = {}) {
  options = Object.assign({}, {duration: 300}, options);
  if (container) {
    options.container = container;
  }
  Velocity(target, 'stop');
  Velocity(target, 'scroll', options);
};


const actionSet = new Set();
export function preventDuplicateCall({id, wait = 10000}, action) {
  if (!id) {
    throw new Error('invalid aciton id');
  }

  if (actionSet.has(id)) {
    return;
  }

  actionSet.add(id);
  action();

  setTimeout(() => {
    actionSet.delete(id);
  }, wait)
}